/**
 * EmptyStateChatOpen · 侧栏 AI 助手对话「已打开」时的文件夹列表空态（设计稿 12:3368）
 *
 * 与侧栏关闭态（EmptyState 主体：推荐卡片 + 自定义输入）互斥 —— 由 EmptyState 在
 * sidebarOpen 时渲染本组件。此态更紧凑，仅引导用户去右侧侧栏与 AI 对话：
 *  · 圆形浅紫底 + 右箭头图标
 *  · 标题「在右侧和 AI 助手对话」
 *  · 一段引导文案（含团队待归类照片数，数据同 Header 统计）
 *  · 仅管理员可见的「或 手动新建文件夹」链接
 *
 * 待归类照片数沿用 useGroupPhotoNumFormated（与关闭态、Header 同源同格式）；
 * 统计未就绪时省略该句前缀，其余文案照常展示。
 */

import React from 'react'
import { ArrowRightOutlined } from '@ant-design/icons'
import { useGroupPhotoNumFormated } from '../../../../app/hooks/useGroupPhotoNumFormated'
import { trackClassifyClick } from '../../utils/trackClassify'
import styles from './EmptyStateChatOpen.module.scss'

export interface EmptyStateChatOpenProps {
  /**
   * 透传父级注入的「新建文件夹」回调
   *  · 非管理员场景父级不会注入（BFF 会拒，UI 隐藏入口）
   */
  onCreateFolder?: () => void
}

const EmptyStateChatOpen: React.FC<EmptyStateChatOpenProps> = ({
  onCreateFolder
}) => {
  const photoNum = useGroupPhotoNumFormated()

  return (
    // data-no-box-select · 与关闭态一致，整个 empty 区不参与框选
    <div className={styles.empty} data-no-box-select>
      <div className={styles.group}>
        <div className={styles.hero} aria-hidden="true">
          <ArrowRightOutlined />
        </div>
        <div className={styles.texts}>
          <h2 className={styles.title}>在右侧和 AI 助手对话</h2>
          <p className={styles.desc}>
            {photoNum && (
              <>
                团队当前有
                <strong className={styles.num}>{photoNum.value}</strong>
                {photoNum.unit}照片待归类，
              </>
            )}
            告诉 AI
            你想怎么整理照片，它会基于团队照片生成分类方案，确认后即可创建文件夹
          </p>
        </div>
      </div>

      {onCreateFolder && (
        <div className={styles.fallback}>
          <span className={styles.fallbackHint}>或</span>
          <button
            type="button"
            className={styles.fallbackLink}
            onClick={() => {
              trackClassifyClick('createFolder')
              onCreateFolder()
            }}
          >
            手动新建文件夹
          </button>
        </div>
      )}
    </div>
  )
}

export default EmptyStateChatOpen
